export default __webpack_public_path__ + "static/image4-08e77fc8e01425b0188a300c686737c7.jpg";